module.exports = __webpack_public_path__ + "assets/img/wdl.dbe8aa1f.svg";